import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    zIndex: 10,
    height: "auto",
    margin: "0 8px",
    padding: "8px 0 25px 0",
    background: theme(props).keyPalette.panelBackgroundColor,
    borderTop: theme(props).border.solid,
}));

export const ActionButtonsWrapper = styled.div({
    padding: "5px 20px 15px 20px",
    margin: "0 -8px",
});

export const ActionsBar = styled.div(() => ({
    padding: "10px 15px 10px 15px",
    display: "flex",
    justifyContent: "space-between",
}));

export const ActionsBarButton = styled.button<{ active?: boolean; disabled?: boolean; loading?: boolean }>(
    props => ({
        flex: "0 0 32px",
        display: "inline-block",
        fontSize: "20px",
        width: 32,
        height: 32,
        borderRadius: 16,
        backgroundColor: !props.active ? "transparent" : theme(props).lists.items.accentLow.backgroundColor,
        border: 0,
        padding: 0,
        lineHeight: "32px",
        textAlign: "center",
        position: "relative",
        margin: 0,
        outline: 0,
        color: !props.disabled ? theme(props).typography.primary.color : theme(props).typography.secondary.color,

        ":active":
            props.disabled || props.loading
                ? {}
                : {
                      backgroundColor: theme(props).menu.hoveredBackgroundColor,
                      color: theme(props).typography.primary.color,

                      "> span": {
                          position: "relative",
                          top: 1,
                          left: 1,
                      },
                  },

        ":focus-visible": {
            boxShadow: `0 0 0 2px ${theme(props).valueControls.highlightedBorderColor}, 0 0 0 2px ${
                theme(props).valueControls.focusedInsetColor
            } inset`,
        },
    }),
    props => ({
        ":hover":
            props.disabled || props.loading
                ? {}
                : {
                      backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
                      color: theme(props).typography.primary.color,
                      cursor: "pointer",
                  },
    })
);

export const PopupContainer = styled.div({
    width: 220,
    padding: 15,
});

export const PopupList = styled.ul({
    padding: 0,
    margin: 0,
    listStyle: "none",
    display: "block",
});

export const PopupItem = styled.li<{ borderTop?: boolean; borderBottom?: boolean }>(
    props => ({
        padding: "5px 15px",
        margin: "0 -15px",
        cursor: "pointer",

        ":hover": {
            backgroundColor: theme(props).lists.items.accentLow.backgroundColor,
        },
    }),
    props =>
        props.borderTop && {
            borderTop: theme(props).border.solid,
            marginTop: "5px",
        },
    props =>
        props.borderBottom && {
            borderBottom: theme(props).border.solid,
            marginBottom: "5px",
        }
);

export const PopupItemAction = styled.a(props => ({
    color: theme(props).typography.primary.color,
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textDecoration: "none",
}));
